import { analytics } from "@/firebase.setup";
import { logEvent } from "@firebase/analytics";

export const logSearchTerm = (searchTerm: string): void => {
  logEvent(analytics, "search", {
    search_term: searchTerm,
  });
};
